import { Ajax } from "../utils/base";
import IP from "../config/config"
import Qs from "qs"
// 顶部卡片信息
export function getDataTypeListApi (param) {
    const url = IP.dcApis() + '/data/getDataTypeList';
    return Ajax(url, Qs.stringify(param), "POST");
}
// 大数据报告-历史推荐
export function getColdHisApi (param, urlApi) {
    const url = IP.djApis() + urlApi;
    return Ajax(url, param, "GET");
}
// 大数据报告-今日推荐
export function getForwardApi (param) {
    const url = IP.dcApis() + '/data/forward';
    return Ajax(url, param, "GET");
}
// 检测是否自动续费
export function iosIsAutoPay (param) {
    const url = IP.passportApis() + '/data/getAutoPaySetMeal';
    return Ajax(url, param, "GET");
}
// 用户信息
export function getUser (param) {
    const url = IP.passportApis() + '/user/info';
    return Ajax(url, Qs.stringify(param), "POST");
}
// 比赛详情页模型
export function getModelListForMatch (param) {
    const url = IP.mApis() + '/api/match/detail/mould/list';
    return Ajax(url, param, "GET");
}
// 情报速递
export function getReportList (param) {
    const url = IP.mApis() + '/api/mould/information/list';
    return Ajax(url, param, "GET");
}
// 情报速递
export function getInformationFreeBuy (param) {
    const url = IP.mApis() + '/passport/pay/information/free-buy';
    return Ajax(url, param, "POST");
}
// 情报速递
export function getOddsWaveDetails (param) {
    const url = IP.mApis() + '/api/mould/data/dis-analy';
    return Ajax(url, param, "GET");
}
